import React, { ReactElement } from 'react';

import { classNames } from '@/helpers/classNames';

import styles from './BottomActionLayout.module.scss';

export interface BottomActionLayoutProps {
	topContent?: ReactElement;
	actionDivider?: boolean;
	actionHidden?: boolean;
	actionContent?: ReactElement | null;
	actionTopContent?: ReactElement;
	noPadding?: boolean;
	className?: string;
	contentClassName?: string;
	listClassName?: string;
	actionContentClassName?: string;
	bottomSheetOpen?: boolean;
	bottomSheetContent?: ReactElement;
	onBottomSheetClose?: () => void;
	bottomPanelOpen?: boolean;
	bottomPanelOverlay?: boolean;
	bottomPanelContent?: ReactElement;
	onBottomPanelClose?: () => void;
	onScroll?: (scrollTop: number, offsetHeight: number) => void;
	isScrollable?: boolean;
	contentStyle?: React.CSSProperties;
}

export const BottomActionLayout: React.FC<BottomActionLayoutProps> = ({
	topContent,
	children,
	actionHidden,
	noPadding,
	actionContent,
	actionTopContent,
	actionDivider,
	className,
	contentClassName,
	contentStyle,
	actionContentClassName,
	listClassName,
	bottomSheetOpen,
	bottomSheetContent,
	onBottomSheetClose,
	bottomPanelOpen,
	bottomPanelOverlay = true,
	bottomPanelContent,
	onBottomPanelClose,
	onScroll,
	isScrollable = true,
}) => {
	const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
		if (onScroll) {
			onScroll(
				event.currentTarget.scrollTop,
				event.currentTarget.offsetHeight,
			);
		}
	};

	return (
		<div className={classNames([styles['layout'], className])}>
			{!!topContent && (
				<>
					<div
						className={classNames([
							styles['list'],
							noPadding && styles['no-padding'],
							listClassName,
						])}
					>
						{topContent}
					</div>
				</>
			)}
			<div
				className={classNames([
					styles['content'],
					isScrollable && styles['scrollable'],
					contentClassName,
				])}
				onScroll={handleScroll}
				style={contentStyle}
			>
				<div
					className={classNames([
						styles['list'],
						noPadding && styles['no-padding'],
						listClassName,
					])}
				>
					{children}
				</div>
			</div>
			{/* The overlay for the Bottom Sheet */}
			<div
				className={classNames([
					styles['bottom-sheet-overlay'],
					bottomSheetOpen && styles['active'],
				])}
				onClick={onBottomSheetClose}
			/>
			{/*
        The overlay for the Bottom Panel.
        We need two separate divs here as they trigger different
        onClick callbacks
      */}
			<div
				className={classNames([
					styles['bottom-sheet-overlay'],
					bottomPanelOpen && bottomPanelOverlay && styles['active'],
				])}
				onClick={onBottomPanelClose}
			/>

			{!actionHidden && (
				<>
					<div
						className={classNames([
							styles['action-container'],
							actionDivider && styles['with-divider'],
						])}
					>
						<div
							className={classNames([
								styles['bottom-sheet'],
								bottomSheetOpen && styles['active'],
							])}
						>
							{bottomSheetContent}
						</div>
						<div className={styles['mask']}></div>
						<div
							className={classNames([
								styles['content'],
								actionContentClassName,
							])}
						>
							<div className={styles['top-content']}>
								{actionTopContent ? actionTopContent : null}
							</div>
							<div
								className={classNames([
									styles['action'],
									styles['even-flex'],
								])}
							>
								{actionContent}
							</div>
						</div>
					</div>
				</>
			)}

			<div
				className={classNames([
					styles['bottom-panel'],
					bottomPanelOpen && styles['active'],
				])}
			>
				{!!bottomPanelOpen && bottomPanelContent}
			</div>
		</div>
	);
};
